import { client } from "api";

export type BookingListing = {
  id: string;
  title: string | null;
  startTime: string;
  endTime: string;
  orderNumber: string | null;
  status: number;
  assigneeId: string | null;
  assigneeName: string | null;
};

export type GetMyBookingsResponse = BookingListing[];

export const getMyBookings = () =>
  client.get<GetMyBookingsResponse>(`/user/get-my-bookings`).then((res) => res.data);
